import { HttpLink, ApolloLink, ApolloClient } from "apollo-boost";
import resolvers from "../resolvers";
import { errorLink, authMiddleware, cache } from "./ApolloClientCache";
import { createUploadLink } from "apollo-upload-client";

// const httpLink = createUploadLink({ uri: "https://atlantis-shop.berfes.ir" });
const httpLink = createUploadLink({ uri: "https://shopapi.atldmo.ir/" });

const link = ApolloLink.from([errorLink, authMiddleware.concat(httpLink)]);

export const shopClient = new ApolloClient({
  cache,
  link,
  resolvers: {
    Mutation: {
      ...resolvers
    }
  },
  queryDeduplication: true
});
